export default {"src":"/_next/static/media/speed.0c8e4b58.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};